import React from 'react';
import PropTypes from 'prop-types';



import CloseIconImage from '../../../../public/images/icons/icon-close.svg';

import styles from './CloseIcon.scss';


function CloseIcon(props) {

    return (
        <a
            {...props}
            className={styles.iconClose}
            onClick={event => {

                event.preventDefault();
                event.stopPropagation();

                props.onClick();
            }}
        >
            <CloseIconImage/>
        </a>
    );
}


CloseIcon.propTypes = {
    onClick: PropTypes.func.isRequired
};

CloseIcon.defaultProps = {};


export default CloseIcon;
